var _rect, _rect2, _rect3, _line, _line2, _line3, _line4, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.19922,
    y: 3.19916,
    width: 4,
    height: 4,
    rx: 1,
    fill: "#2C2C2C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.19922,
    y: 8.19916,
    width: 4,
    height: 4,
    rx: 1,
    fill: "#2C2C2C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.19922,
    y: 3.19916,
    width: 4,
    height: 4,
    rx: 1,
    fill: "#2C2C2C"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 11.4805,
    y1: 9.23041,
    x2: 11.4805,
    y2: 11.4492,
    stroke: "#2C2C2C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 11.4492,
    y1: 11.4648,
    x2: 10.9492,
    y2: 11.4648,
    stroke: "#2C2C2C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 9.54297,
    y1: 9.23041,
    x2: 9.04297,
    y2: 9.23041,
    stroke: "#2C2C2C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 8.99609,
    y1: 9.82416,
    x2: 8.99609,
    y2: 9.32416,
    stroke: "#2C2C2C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.97266,
    cy: 11.4882,
    r: 0.773438,
    fill: "#2C2C2C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1678 14.6483C10.1678 14.234 10.5036 13.8983 10.9178 13.8983H12.6483C13.3386 13.8983 13.8983 13.3386 13.8983 12.6483V10.7304C13.8983 10.3162 14.234 9.98041 14.6483 9.98041C15.0625 9.98041 15.3983 10.3162 15.3983 10.7304V12.6483C15.3983 14.167 14.167 15.3983 12.6483 15.3983H10.9178C10.5036 15.3983 10.1678 15.0625 10.1678 14.6483ZM0.75 9.98041C1.16421 9.98041 1.5 10.3162 1.5 10.7304V12.6483C1.5 13.3386 2.05964 13.8983 2.75 13.8983H4.85535C5.26956 13.8983 5.60535 14.234 5.60535 14.6483C5.60535 15.0625 5.26956 15.3983 4.85535 15.3983H2.75C1.23122 15.3983 0 14.167 0 12.6483V10.7304C0 10.3162 0.335786 9.98041 0.75 9.98041ZM5.60535 0.75C5.60535 1.16421 5.26956 1.5 4.85535 1.5H2.75C2.05964 1.5 1.5 2.05964 1.5 2.75V4.66791C1.5 5.08212 1.16421 5.41791 0.75 5.41791C0.335786 5.41791 0 5.08212 0 4.66791V2.75C0 1.23122 1.23122 0 2.75 0H4.85535C5.26956 0 5.60535 0.335786 5.60535 0.75ZM10.1678 0.75C10.1678 1.16421 10.5036 1.5 10.9178 1.5H12.6483C13.3386 1.5 13.8983 2.05964 13.8983 2.75V4.66791C13.8983 5.08212 14.234 5.41791 14.6483 5.41791C15.0625 5.41791 15.3983 5.08212 15.3983 4.66791V2.75C15.3983 1.23122 14.167 0 12.6483 0H10.9178C10.5036 0 10.1678 0.335786 10.1678 0.75Z",
    fill: "#2C2C2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrImg);
export default __webpack_public_path__ + "static/media/qr-img.ad018505160c631359cd533b2ce2538d.svg";
export { ForwardRef as ReactComponent };